// extracted by mini-css-extract-plugin
export var actionButton = "_ct-t";
export var buttonContainer = "_ct-0";
export var buttonContainer2 = "_ct-1";
export var buttonSection = "_ct-2";
export var details = "_ct-3";
export var dropdownItem = "_ct-5";
export var dropdownItemsContainer = "_ct-4";
export var fileInput = "_ct-r";
export var headerButton = "_ct-6";
export var icon = "_ct-7";
export var input = "_ct-8";
export var macroListItem = "_ct-9";
export var mainContent = "_ct-a";
export var microText = "_ct-b";
export var modal = "_ct-w";
export var optionsButton = "_ct-c";
export var paperclip = "_ct-s";
export var pillContent = "_ct-d";
export var preview = "_ct-e";
export var preview2 = "_ct-f";
export var quillEditor = "_ct-q";
export var selectedMacro = "_ct-g";
export var sidebar = "_ct-h";
export var sidebarHeader = "_ct-j";
export var sidebarList = "_ct-i";
export var sidebarListItem = "_ct-k";
export var sidebarSearch = "_ct-l";
export var snoozeDurationWrapper = "_ct-v";
export var statusPillContainer = "_ct-m";
export var tagsContainer = "_ct-n";
export var unselectedMacro = "_ct-o";
export var variable = "_ct-u";
export var wrapper = "_ct-p";